<header class="cart-page-header">
  <nav class="navbar container-fluid">
    <div class="brand">
      <a routerLink="/" class="brand-link">
        <img src="assets/images/Veeduplan logo.png" alt="VeeduPlan Logo" class="logo">
      </a>
    </div>
  </nav>
</header>

<section class="thank-you-section">
  <div class="container text-center py-5">
    <div class="thank-you-card box-shadow-large border-radius-8px p-5 bg-white" *ngIf="isLoaded">
      <i *ngIf="isSuccess" class="fas fa-check-circle text-success mb-4" style="font-size: 5rem; color: #28a745;"></i>
      <i *ngIf="!isSuccess" class="fas fa-exclamation-circle text-danger mb-4" style="font-size: 5rem; color: #b91d1d;"></i>
      <h1 class="mb-3">{{title}}</h1>
      <p class="fs-18 mb-4" [innerHTML]="message"></p>
      <p [innerHTML]="messageItem"></p>
      <button class="btn btn-primary" routerLink="/home" style="background-color: #c4041c; border-color: #c4041c;">Return to Home</button>
    </div>
    <div *ngIf="!isLoaded">
      <p class="fs-18 mb-4">We are fetching your payment status please wait don't close this window...</p>
    </div>
  </div>
</section>
<app-footer></app-footer>
